import TableModel from "./shared/TableModel.js";
import ExportModel from "../export/shared/ExportModel.js";
import ExportFields from "../export/ExportFields.js"; // eslint-disable-next-line import/prefer-default-export
export function createTableExportModel(value, objectType) {
  if (!objectType) {
    return null;
  }
  const columns = TableModel.getColumns(value);
  const fieldCreators = [];
  if (columns && columns.length > 0) {
    columns.forEach(column => {
      const fieldCreator = ExportFields.getExportField(column.attrName, objectType);
      if (fieldCreator) {
        fieldCreators.push({
          fieldCreator,
          formatter: column.formatter
        });
      }
    });
  }
  if (fieldCreators.length > 0) {
    return ExportModel.create({
      fields: fieldCreators.map(creator => creator.fieldCreator.create({
        formatter: creator.formatter
      }))
    });
  }
  return ExportModel.create({
    fields: ExportFields.getExportFieldsFor(objectType).map(creator => creator.create())
  });
}